import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

import DividerLeft from 'aulatime/src/components/DividerLeft';
import DividerRight from 'aulatime/src/components/DividerRight';

import ModalContact from 'aulatime/src/components/ModalContact';

const SectionBrushUp = () => {

  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            station {
              metadata {
                domain
                shortcode
              }
            }
          }
        }
        img: file(relativePath: { eq: "img_brush-up.png" }) {
          childImageSharp {
            fixed(width: 400) {
              ...GatsbyImageSharpFixed
            }
          }
        }
      }
    `
  );

  const postmanpConfig = {
    metadata: {
      ...data.site.siteMetadata.station.metadata,
      ...{ lang: process.env.GATSBY_LOCALE || 'en' },
      ...{ form: 'contact', section: '#Conversation' }
    }
  };

  return (
    <section id="brush-up">
      <DividerRight/>

      <div className="container">
        <div className="row">

          <div className="col text-center">
            <h1 className="text-white mb-0 pb-0">Conversation Classes</h1>
            <h2 className="text-primary-2 pb-4">Brush Up Your Spanish</h2>
          </div>

        </div>
      </div>
      <div className="container">
        <div className="row">

          <div className="col-lg-6 col-md-5 col-12 d-flex">
            <Img
              fixed={data.img.childImageSharp.fixed}
              className="mb-md-0 mb-4 mt-md-2 mx-auto"
              alt="Aula Spanish Time"
            />
          </div>
          <div className="col-lg-6 col-md-7 col-12 text-md-left text-center">
            <p className="lead text-white">Already speak Spanish but want to take it to the next level? We have the perfect class for you!</p>
            <p className="text-white">Our <span className="text-primary-2"><strong>short, focused sessions</strong></span> fit seamlessly into busy schedules and are packed with colloquialisms, rapid-fire expressions, and native-like nuances. You'll master the tone and rhythm of real conversations, whether you want to <span className="text-primary-2"><strong>stand</strong></span> out or <span className="text-primary-2"><strong>blend in effortlessly</strong></span>.</p>
            <p className="text-white lead pb-3">Stay sharp and speak like a native!</p>

            <div>
              <ModalContact
                header="Find Out More"
                button={(onClick) => (
                  <button type="button" className="btn btn-xl btn-light" onClick={onClick}>Find Out More</button>
                )}
                postmanpConfig={postmanpConfig}
              />
            </div>

          </div>
        </div>
      </div>

      <DividerLeft/>
    </section>
  );
}

export default SectionBrushUp;
